import actionTypes from '../../actions/dictionaries/dictionaries.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LOTTERY_TERMS_DICTIONARY_SUCCESS:
      return { ...action.terms };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/lottery-terms-dictionary.js